import { useCallback } from 'react';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Icon = (props) => (
  <svg {...props} viewBox="0 0 467.765 467.765">
    <path
      fill="currentColor"
      d="M360.345 233.882c29.835-24.139 48.949-61.04 48.949-102.324C409.294 59.013 350.281 0 277.735 0H58.471v58.471h29.235v350.824H58.471v58.471h219.265c72.546 0 131.559-59.013 131.559-131.559-.001-41.285-19.115-78.186-48.95-102.325zm-82.61 175.412H146.176V263.118h131.559c40.299 0 73.088 32.79 73.088 73.088s-32.789 73.088-73.088 73.088zm0-204.647H146.176V58.471h131.559c40.299 0 73.088 32.79 73.088 73.088s-32.789 73.088-73.088 73.088z"
    />
  </svg>
);

const Bold = ({ onItemClick, value, ...otherProps }) => {
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(() => {
    quillRef.current.format('bold', !value, 'user');
    onItemClick();
  }, [value]);

  return (
    <Tooltip initialPosition={POSITIONS.BOTTOM} childrenElement={__('Bold')}>
      <ToolbarItem
        onClick={handleToggleValue}
        isActive
        icon={Icon}
        {...otherProps}
      />
    </Tooltip>
  );
};

Bold.getFormat = (format) => format?.bold;

export default Bold;
